import React, { useState } from "react";
import { Link } from "react-router-dom";
import api from "../../api/sellerApi";
import StarRating from "../../components/StarRating";

const categories = [
  { value: "app_experience", label: "App Experience" },
  { value: "delivery_process", label: "Delivery Process" },
  { value: "support", label: "Support" },
  { value: "feature_request", label: "Feature Request" },
  { value: "other", label: "Other" },
];

export default function Feedback() {
  const [category, setCategory] = useState("");
  const [message, setMessage] = useState("");
  const [rating, setRating] = useState(0);
  const [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = async () => {
    if (!category) {
      alert("Please select a category.");
      return;
    }
    if (!message.trim()) {
      alert("Please write a message.");
      return;
    }
    setSubmitting(true);
    try {
      await api.post("/feedback", {
        category,
        message: message.trim(),
        rating: rating || null,
      });
      setSubmitted(true);
    } catch (err) {
      alert(err.response?.data?.error || "Failed to submit feedback.");
    } finally {
      setSubmitting(false);
    }
  };

  if (submitted) {
    return (
      <div className="min-h-screen bg-green-500 flex flex-col items-center justify-center px-6 text-center">
        <div className="w-20 h-20 bg-white rounded-full flex items-center justify-center mb-6">
          <svg
            className="w-10 h-10 text-green-500"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={2.5}
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M5 13l4 4L19 7"
            />
          </svg>
        </div>
        <h1 className="text-2xl font-bold text-white mb-2">Thank you!</h1>
        <p className="text-green-100 text-lg mb-8">
          Your feedback helps us improve the platform.
        </p>
        <Link
          to="/seller/account"
          className="bg-white text-green-600 px-8 py-3 rounded-2xl font-bold text-lg"
        >
          Back to Account
        </Link>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <div className="bg-green-600 text-white px-5 pt-6 pb-8 rounded-b-3xl">
        <div className="flex items-center gap-3 mb-2">
          <Link to="/seller/account" className="text-green-200">
            <svg
              className="w-6 h-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth={2}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M15 19l-7-7 7-7"
              />
            </svg>
          </Link>
          <h1 className="text-xl font-bold">Give Feedback</h1>
        </div>
        <p className="text-green-200 text-sm">
          Help us improve your experience
        </p>
      </div>

      <div className="px-5 mt-6 space-y-5 pb-8">
        {/* Category Selection */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Category
          </label>
          <div className="flex flex-wrap gap-2">
            {categories.map((cat) => (
              <button
                key={cat.value}
                onClick={() => setCategory(cat.value)}
                className={`px-4 py-2 rounded-xl text-sm font-medium border-2 transition-all ${
                  category === cat.value
                    ? "border-green-600 bg-green-50 text-green-700"
                    : "border-gray-200 bg-white text-gray-600"
                }`}
              >
                {cat.label}
              </button>
            ))}
          </div>
        </div>

        {/* Optional Rating */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Overall rating (optional)
          </label>
          <StarRating value={rating} onChange={setRating} size={36} />
        </div>

        {/* Message */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Your feedback
          </label>
          <textarea
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            rows={5}
            placeholder="Tell us what's on your mind..."
            className="w-full border-2 border-gray-200 rounded-2xl p-4 text-gray-700 focus:border-green-500 focus:ring-2 focus:ring-green-200 resize-none"
          />
        </div>

        {/* Submit */}
        <button
          onClick={handleSubmit}
          disabled={submitting}
          className="w-full py-4 rounded-2xl bg-green-600 text-white font-bold text-lg disabled:opacity-50"
        >
          {submitting ? "Submitting..." : "Submit Feedback"}
        </button>
      </div>
    </div>
  );
}
